// extracted by mini-css-extract-plugin
export default {"importantNote":"ImportantNoteComp_importantNote__AHhie","noteText":"ImportantNoteComp_noteText__YWxeo"};